import { gql } from '@apollo/client/core';

const ActivateJobsInquiryMutation = gql`
  mutation activateJobsInquiry($input: ActivateJobsInquiryInput!) {
    activateJobsInquiry(input: $input) {
      id
      lastActiveAt
      activable
    }
  }
`;
export default ActivateJobsInquiryMutation;
